'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import * as cosIndexConnectionsSelectors from 'DesignData/selectors/cosIndexConnections';
import { dependentsByCategory as DependentsByCategoryPropType } from 'DesignData/propTypes/finder';
import makeAsyncModal from 'DesignComponents/modals/makeAsyncModal';
const UpdateHostTemplateTypeModal = makeAsyncModal(() => import(
/* webpackChunkName: "convert-modals" */
'DesignEditorsUI/components/modals/UpdateHostTemplateTypeModal'));

function makeMapStateToProps() {
  const getCustomWidgetBuffer = customWidgetBuffersSelectors.makeGetCustomWidgetBuffer();
  const getDependentsByCategory = cosIndexConnectionsSelectors.makeGetParentConnectionsByCategory();
  const getDependentsCount = cosIndexConnectionsSelectors.makeGetParentConnectionsCount();
  return function mapStateToProps(state, props) {
    const {
      hostTemplateTypes,
      id
    } = getCustomWidgetBuffer(state, props) || {};
    return {
      hostTemplateTypes,
      customWidgetId: id,
      dependentsCount: getDependentsCount(state, {
        assetId: id
      }),
      dependentsByCategory: getDependentsByCategory(state, {
        assetId: id
      })
    };
  };
}

export default function withUpdateTemplateTypeModal(WrappedComponent) {
  class HighOrderWithUpdateTemplateTypeModal extends Component {
    constructor(props) {
      super(props);

      this.handleUpdateTemplateCallback = newTypes => {
        if (newTypes) {
          this.props.updateCustomWidget(newTypes);
        }

        this.handleUpdateModalClose();
      };

      this.handleUpdateModalClose = () => {
        this.setState({
          open: false
        });
      };

      this.handleUpdateHostTemplateTypesClick = () => {
        this.setState({
          open: true
        });
      };

      this.state = {
        open: false
      };
    }

    renderUpdateTemplateModal() {
      const {
        open
      } = this.state;
      const {
        hostTemplateTypes,
        dependentsByCategory,
        customWidgetId,
        dependentsCount
      } = this.props;

      if (!open) {
        return null;
      }

      return /*#__PURE__*/_jsx(UpdateHostTemplateTypeModal, {
        hostTemplateTypes: hostTemplateTypes,
        callback: this.handleUpdateTemplateCallback,
        dependentsByCategory: dependentsByCategory,
        customWidgetId: customWidgetId,
        dependentsCount: dependentsCount
      });
    }

    render() {
      const renderedUpdateTemplateModal = this.renderUpdateTemplateModal();
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        updateTemplateModal: renderedUpdateTemplateModal,
        onUpdateHostTemplateTypesClick: this.handleUpdateHostTemplateTypesClick,
        handleOnboardingUpdatedTemplate: this.handleOnboardingUpdatedTemplate
      }));
    }

  }

  HighOrderWithUpdateTemplateTypeModal.propTypes = {
    hostTemplateTypes: PropTypes.array.isRequired,
    updateCustomWidget: PropTypes.func.isRequired,
    customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
    dependentsByCategory: DependentsByCategoryPropType,
    dependentsCount: PropTypes.number
  };
  return connect(makeMapStateToProps, null)(HighOrderWithUpdateTemplateTypeModal);
}